import React, { forwardRef } from 'react'
import { type FormContextValues, Controller } from 'react-hook-form'
import { CheckboxWithLabel } from '@retailer-platform/shared-components'
import { type DomainMessages, useDomainMessage } from 'domains/collections/utils/domain/intl'
import { type CollectionsFormData } from 'domains/collections/components/collections-form/utils/collectionsForm.types'
import { type ControllerProps } from 'utils/react-hook-form/reactHookForm.types'

interface CollectionsFormCheckboxProps extends Omit<ControllerProps, 'name'> {
  control: FormContextValues<CollectionsFormData>['control']
  identifier?: string
  labelId?: DomainMessages
}

export const CollectionsFormCheckbox = forwardRef<HTMLInputElement, CollectionsFormCheckboxProps>(
  ({ labelId, identifier, control, 'data-testid': testId }, ref) => {
    const label = useDomainMessage(labelId)

    return (
      <React.Fragment>
        <Controller
          as={CheckboxWithLabel}
          name={identifier}
          id={identifier}
          control={control}
          label={label}
          data-testid={testId}
        />
      </React.Fragment>
    )
  }
)
